<template>
  <div style="height: 100%">
    <!--      头部      -->
    <div class="iq-top-navbar">
      <el-page-header @back="$router.go(-1)" content="素材"> </el-page-header>
    </div>
    <!--    内容    -->
    <div class="center-content">
      <div class="iq-card-body flex-space-between">
        <div class="flex-space-between box">
          <div class="flex-center bottom-box" @click="editFolder">
            <img style="width: 18px; height: 18px; margin-right: 5px" src="../../../assets/img/shopping/editor.png" />
            <span>重命名</span>
          </div>
          <div class="line-box2"></div>
          <div class="flex-center bottom-box" @click="removeFolder">
            <img style="width: 18px; height: 18px; margin-right: 5px" src="../../../assets/img/shopping/delete.png" />
            <span>删除</span>
          </div>
        </div>
        <div class="left-box">
          <div class="flex-space-between top-box">
            <span>文件夹目录</span>
            <div>
              新建文件夹
              <img style="width: 15px; height: 15px; cursor: pointer" src="../../../assets/img/shopping/add.png" @click="addFolder" />
            </div>
          </div>
          <el-input class="input-box" v-model="searchForm.folderName" type="text" size="small" placeholder="文件夹名称" @keyup.enter.native="Search" clearable>
            <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
          </el-input>
          <el-scrollbar class="left-nav-wrap" style="height: calc(100vh - 320px)">
            <div class="item-box flex-start" :class="{ active: active == index }" v-for="(item, index) in AlbumData" :key="index" @click="getInfo(item, index)">
              <i class="el-icon-folder"></i>
              <span class="oneLine" style="margin-left: 5px">{{ item.name }}</span>
            </div>
          </el-scrollbar>
        </div>
        <div class="line-box"></div>
        <div class="right-box">
          <div class="flex-space-between top-box">
            <span>素材图片</span>
          </div>
          <div class="flex-end">
            <el-input class="input-box2" v-model="searchForm.keyWord" type="text" size="small" placeholder="图片名称" @keyup.enter.native="getImgs" clearable>
              <el-button slot="append" icon="el-icon-search" @click="getImgs"></el-button>
            </el-input>
            <el-checkbox v-model="isAll" style="margin: 0 20px" @change="checkAll">全选</el-checkbox>
            <el-button type="info" round plain size="small" @click="deleteBtn()">批量删除</el-button>
            <el-button
              type="primary"
              round
              size="small"
              @click="
                dialogUpload = true;
                initUpload();
              "
               v-if="AlbumData.length>0">本地上传</el-button
            >
          </div>
          <template v-if="LibraryData.length > 0">
            <el-scrollbar class="left-nav-wrap" style="height: calc(100vh - 280px)">
              <div class="checkGroup flex-start flex-wrap">
                <div class="img-box" :class="{ activeImg: active == index }" v-for="(item, index) in LibraryData" :key="index">
                  <div class="top-btn flex-space-between">
                    <el-checkbox v-model="item.isCheck" size="medium" @change="handelCheck"></el-checkbox>
                    <i class="el-icon-delete" style="background-color: #fff; color: #000; padding: 2px; border-radius: 5px; cursor: pointer" @click="delImage(item.id)"></i>
                  </div>
                  <img
                    :src="`${CommonPath}${item.filePath}`"
                    @click="
                      dialogVisible = true;
                      dialogImageUrl = `${CommonPath}${item.filePath}`;
                    "
                  />
                  <div class="oneLine" style="margin-left: 5px; text-align: center">{{ item.fileName }}</div>
                </div>
              </div>
            </el-scrollbar>
            <el-pagination @current-change="ChangePage" :page-size="PageSize" :current-page="PageIndex" :total="DataTotal" layout="total, prev, pager, next, jumper"></el-pagination>
          </template>
          <el-empty :image-size="110" v-else style="height: calc(100vh - 250px)"></el-empty>
        </div>
      </div>
    </div>
    <!--    新增相册    -->
    <!-- 添加或修改菜单对话框 -->
    <el-dialog :title="title" :visible.sync="formDialog" width="600px" append-to-body @close="cancel('form')">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="文件夹名称" prop="name" style="width: 95%">
          <el-input v-model="form.name" placeholder="请输入文件夹名称" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="上传图片" :visible.sync="dialogUpload">
      <el-upload :headers="headers" :action="CommonFilePath" list-type="picture-card" :limit="5" multiple :on-preview="handleImagePreview" :on-remove="handleImageRemove" :on-success="handleImageUpload" ref="upload1" :on-exceed="$imgConfig.exceed" :before-upload="$imgConfig.onBeforeUpload20M" accept=".png,.jpg,.jpeg,.gif">
        <i class="el-icon-plus"></i>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，最多上传5张，单张大小不超过20M</div>
      </el-upload>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUpload = false">取 消</el-button>
        <el-button type="primary" @click="uploadBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { MaterialLibrary } from "../../../components/HospitalDomain/ShopMall/MaterialLibrary";

export default {
  name: "Album",
  computed: {
    headers() {
      return {
        Authorization: "Bearer" + " " + JSON.parse(sessionStorage.getItem(this.ClientId + "Token")).access_token,
      };
    },
  },
  data() {
    var materialLibrary = new MaterialLibrary(this.TokenClient, this.Services.Shopping);
    return {
      MaterialLibrary: materialLibrary,
      organizationId: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      Keyword: "",
      AlbumData: [],
      PageIndex: 1,
      PageTotal: 0,
      PageSize: 0,
      DataTotal: 0,
      active: 0,
      searchForm: {
        keyWord: "",
        folderName: "",
      },
      form: {
        id: 0,
        name: "",
        organizationId: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      },
      title: "",
      formDialog: false,
      http: this.CommonPath,
      rules: {
        name: [{ required: true, message: "请输入相册名称", trigger: "blur" }],
      },
      LibraryData: [],
      isAll: false,
      checked: [],
      dialogUpload: false,
      //单击图片上传控件中的图片时，放大显示
      dialogVisible: false,
      dialogImageUrl: "",
      ImageContent: [], //图片列表
      ImageContentList: [], //图片上传控件加载的数据
      fileManage: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    initUpload() {
      this.fileManage = [];
      this.ImageContent = [];
      if (this.$refs.upload1) {
        this.$refs.upload1.clearFiles();
      }
    },
    handleImageUpload(response, file, fileList) {
      var _this = this;
      response.forEach(function (res) {
        var imgarr = {
          filePath: res.completeFilePath,
          fileName: file.name,
          type: 0,
          materialLibraryId: _this.AlbumData[_this.active].id,
          organizationId: _this.AlbumData[_this.active].organizationId,
        };

        _this.ImageContent.push(imgarr);
      });
      _this.fileManage = _this.ImageContent;
    },
    handleImagePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleImageRemove(file, fileList) {
      var _this = this;
      const filePath = file.response[0].completeFilePath;
      //2.从pics数组中找到图片对应的索引值
      //形参‘x’，是数组pic里的每一项
      const i = _this.ImageContent.findIndex((x) => x.filePath == filePath);
      //调用数组的splice方法，把图片的信息对象从pics数组中移除
      _this.ImageContent.splice(i, 1);
      _this.fileManage = _this.ImageContent;
    },
    uploadBtn() {
      var _this = this;
      if (_this.fileManage.length == 0) {
        _this.$message({
          type: "error",
          message: "请上传图片!",
        });
        return;
      }
      _this.MaterialLibrary.UploadImg(
        _this.fileManage,
        function (data) {
          _this.$message({
            type: "success",
            message: "添加成功!",
          });
          _this.dialogUpload = false;
          _this.initUpload();
          _this.getImgs();
        },
        function (err) {}
      );
    },
    handelCheck() {
      this.isAll = this.LibraryData.every((item) => item.isCheck);
    },
    checkAll() {
      this.LibraryData.forEach((item) => {
        item.isCheck = this.isAll;
      });
    },
    getInfo(item, index) {
      this.isAll = false;
      this.active = index;
      var _this = this;
      _this.LibraryData = [];
      _this.MaterialLibrary.LibraryFiles(
        item.organizationId,
        item.id,
        _this.PageIndex,
        _this.searchForm.keyWord,
        function (data) {
          _this.LibraryData = data.data.results;
          _this.LibraryData.forEach((item) => {
            _this.$set(item, "isCheck", false);
          });
          _this.PageIndex = data.data.pageIndex;
          _this.PageSize = data.data.pageSize;
          _this.PageTotal = data.data.pageCount;
          _this.DataTotal = data.data.dataTotal;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    Search() {
      this.getList();
    },
    getImgs() {
      this.PageIndex = 1;
      this.getInfo(this.AlbumData[this.active], this.active);
    },
    delImage(item) {
      var _this = this;
      var params = item;
      _this
        .$confirm("是否删除此张图片?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(() => {
          _this.MaterialLibrary.Remove(
            params,
            function (data) {
              _this.$message({
                type: "success",
                message: "删除成功!",
              });
              _this.getImgs();
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {});
    },
    deleteBtn() {
      let list = this.LibraryData.filter((i) => i.isCheck);
      var _this = this;
      var params = list.flatMap((item) => item.id);
      if (params.length > 0) {
        _this
          .$confirm("确定批量删除选中图片?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
          .then(() => {
            _this.MaterialLibrary.Remove(
              params,
              function (data) {
                _this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                _this.getImgs();
              },
              function (err) {
                console.log(err);
              }
            );
          })
          .catch(() => {});
      } else {
        _this.$message({
          type: "error",
          message: "请选择需要删除的图片!",
        });
      }
    },
    ChangePage(pageIndex) {
      this.PageIndex = pageIndex;
      this.getList();
    },
    getList() {
      var _this = this;
      _this.AlbumData = [];
      _this.MaterialLibrary.OrganizaionList(
        _this.PageIndex,
        _this.searchForm.folderName,
        function (data) {
          _this.AlbumData = data.data.results;
          if (_this.AlbumData.length > 0) {
            _this.active = 0;
            _this.getImgs();
          } else {
            _this.LibraryData = [];
          }
        },
        function (err) {
          console.log(err);
        }
      );
    },
    addFolder() {
      this.title = "新增文件夹";
      this.formDialog = true;
    },
    editFolder() {
      let item = this.AlbumData[this.active];
      this.title = "重命名文件夹";
      this.formDialog = true;
      this.form.name = item.name;
      this.form.id = item.id;
    },
    removeFolder() {
      var _this = this;
      let item = this.AlbumData[this.active];
      if (item.files.length > 0) {
        this.$message({
          type: "error",
          message: "该文件夹下有图片不能删除!",
        });
        return;
      }
      _this.MaterialLibrary.DeleteAlbum(
        item.id,
        function (data) {
          _this.$message({
            type: "success",
            message: "删除成功!",
          });
          _this.getList();
        },
        function (err) {}
      );
    },
    cancel(formName) {
      this.formDialog = false;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.MaterialLibrary.EditAlbum(
            _this.form,
            function (data) {
              _this.$message({
                type: "success",
                message: "添加成功!",
              });
              _this.formDialog = false;
              _this.$refs[formName].resetFields();
              _this.getList();
            },
            function (err) {}
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
/*content*/
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.list-box {
  height: calc(100% - 90px);
  overflow: auto;
}
.el-card {
  width: 250px;
  float: left;
  margin: 20px;
}
.el-card__body .el-image {
  width: 208px;
  height: 208px;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #089bab;
}
</style>
<style scoped>
.iq-card-body {
  position: relative;
}
.left-box {
  width: 20%;
  height: 100%;
}
img {
  width: 100%;
  height: 100%;
}
.right-box {
  width: 76%;
}
.line-box {
  width: 1px;
  background: #e6e6e6;
  height: 100%;
}
.input-box {
  padding: 20px 0;
}
.item-box {
  border-radius: 4px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 10px;
  margin-bottom: 5px;
}
.top-box {
  font-size: 16px;
}
.box {
  position: absolute;
  width: calc(20% + 40px);
  left: 0;
  bottom: 0;
  right: 0;
  border-top: 1px solid #f0f0f0;
}
.bottom-box {
  width: 50%;
  height: 60px;
  cursor: pointer;
}
.line-box2 {
  width: 1px;
  background: #e6e6e6;
  height: 30px;
}
.item-box:hover {
  background: #f0f5ff;
  color: #0a72d3;
}
.active {
  background: #f0f5ff;
  color: #0a72d3;
}
.img-box {
  width: 160px;
  height: 200px;
  border-radius: 12px;
  margin-right: 20px;
  position: relative;
  margin-bottom: 10px;
}
.img-box img {
  width: 160px;
  height: 160px;
  border-radius: 12px;
}
.img-box .top-btn {
  width: 80%;
  position: absolute;
  right: 10px;
  top: 5px;
}
.img-box .top-btn ::v-deep .el-checkbox__inner {
  border: 1px solid #ffffff;
  background-color: #ccc;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--base--Color);
}
.input-box2 {
  padding: 20px 0;
  width: 40%;
}
</style>
